import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import Emergency from "./Emergency";
import NonEmergency from "./NonEmergency";
import LocateNearestHospitalMyLoc from "./pages/LocateNearestHospitalMyLoc.js";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/emergency" element={<Emergency />} />
                <Route path="/non-emergency" element={<NonEmergency />} />
                <Route path="/nearest-hospital" element={<LocateNearestHospitalMyLoc />} />
            </Routes>
        </Router>
    );
}

export default App;
